(function () {
  var stickyReady = false;
  var ecosystemRevealObserver = null;
  var pageMotionObserver = null;

  function syncStickyState() {
    document.documentElement.classList.toggle("lumo-page-scrolled", window.scrollY > 24);
  }

  function initStickyState() {
    if (stickyReady) return;
    stickyReady = true;
    syncStickyState();
    window.addEventListener("scroll", syncStickyState, { passive: true });
    window.addEventListener("resize", syncStickyState);
  }

  function initQuantities(scope) {
    (scope || document).querySelectorAll(".quantity-stepper").forEach(function (stepper) {
      if (stepper.dataset.lumoQuantityReady === "true") return;
      stepper.dataset.lumoQuantityReady = "true";

      var input = stepper.querySelector("input[name='quantity']");
      var display = stepper.querySelector("[data-quantity-display]");
      if (!input) return;

      function sync() {
        var min = Number(input.min || 1);
        var max = Number(input.max || 99);
        var next = Math.min(max, Math.max(min, Number(input.value || min)));
        input.value = String(next);
        if (display) display.textContent = next + (next === 1 ? " item" : " items");
      }

      stepper.querySelectorAll("[data-quantity-action]").forEach(function (button) {
        button.addEventListener("click", function () {
          var delta = button.dataset.quantityAction === "plus" ? 1 : -1;
          input.value = String(Number(input.value || 1) + delta);
          sync();
        });
      });

      input.addEventListener("input", sync);
      input.addEventListener("change", sync);
      sync();
    });
  }

  function initGenericProductGalleries(scope) {
    (scope || document).querySelectorAll("[data-lumo-generic-gallery]").forEach(function (gallery) {
      if (gallery.dataset.lumoGalleryReady === "true") return;

      var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-slide]"));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
      if (!slides.length) return;

      gallery.dataset.lumoGalleryReady = "true";
      gallery.tabIndex = gallery.tabIndex >= 0 ? gallery.tabIndex : 0;

      var prev = gallery.querySelector("[data-gallery-prev]");
      var next = gallery.querySelector("[data-gallery-next]");
      var dragStartX = null;
      var activeIndex = 0;

      function preloadSlide(slide) {
        var image = slide && slide.querySelector("img");
        if (!image) return;
        image.loading = "eager";
        image.decoding = "async";
        var source = image.currentSrc || image.src;
        if (source) {
          var warmImage = new Image();
          warmImage.decoding = "async";
          warmImage.src = source;
        }
      }

      function preloadNeighbors(index) {
        [index, index + 1, index - 1].forEach(function (nextIndex) {
          preloadSlide(slides[(nextIndex + slides.length) % slides.length]);
        });
      }

      function show(index) {
        activeIndex = (index + slides.length) % slides.length;
        gallery.classList.add("is-switching");

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.hidden = !isActive;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        thumbs.forEach(function (thumb, thumbIndex) {
          var isActive = thumbIndex === activeIndex;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        preloadNeighbors(activeIndex);
        window.setTimeout(function () {
          gallery.classList.remove("is-switching");
        }, 180);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(Number(thumb.dataset.galleryIndex || 0));
        });
      });

      if (prev) {
        prev.addEventListener("click", function () {
          show(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          show(activeIndex + 1);
        });
      }

      gallery.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        show(activeIndex + (event.key === "ArrowRight" ? 1 : -1));
      });

      gallery.addEventListener("pointerdown", function (event) {
        if (!event.isPrimary || !event.target.closest(".lumo-generic-product__media-frame")) return;
        dragStartX = event.clientX;
      });

      gallery.addEventListener("pointerup", function (event) {
        if (dragStartX === null) return;
        var delta = event.clientX - dragStartX;
        dragStartX = null;
        if (Math.abs(delta) < 42) return;
        show(activeIndex + (delta < 0 ? 1 : -1));
      });

      preloadNeighbors(0);
      show(0);
    });
  }

  function initEcosystemReveal(scope) {
    var root = scope || document;
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-lumo-ecosystem]"));
    if (root.matches && root.matches("[data-lumo-ecosystem]")) sections.unshift(root);
    if (!sections.length) return;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      sections.forEach(function (section) {
        section.classList.add("is-in-view");
      });
      return;
    }

    if (!ecosystemRevealObserver) {
      ecosystemRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in-view");
            ecosystemRevealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    }

    sections.forEach(function (section) {
      if (section.classList.contains("is-in-view")) return;
      if (section.dataset.lumoRevealReady === "true") return;
      section.dataset.lumoRevealReady = "true";
      ecosystemRevealObserver.observe(section);
    });
  }

  function getSectionBody(wrapper) {
    var child = wrapper.firstElementChild;
    while (child && /^(STYLE|SCRIPT|LINK|TEMPLATE)$/i.test(child.tagName)) {
      child = child.nextElementSibling;
    }
    return child;
  }

  function initPageSectionMotion(scope) {
    var root = scope || document;
    var sections = Array.prototype.slice.call(root.querySelectorAll(".lumo-page-frame__content > .shopify-section"));
    var sectionWrapper = root.closest && root.closest(".lumo-page-frame__content > .shopify-section");
    if (sectionWrapper) sections.unshift(sectionWrapper);
    if (!sections.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    sections.forEach(function (wrapper) {
      var sectionBody = getSectionBody(wrapper);
      if (!sectionBody || wrapper.dataset.lumoPageMotionReady === "true") return;

      wrapper.dataset.lumoPageMotionReady = "true";
      if (sectionBody.classList.contains("site-footer")) {
        wrapper.classList.add("lumo-footer-section");
      }

      var animation = sectionBody.getAttribute("data-lumo-animation") || "sketch";
      wrapper.dataset.lumoPageMotion = "true";
      wrapper.dataset.lumoAnimation = animation;

      if (animation === "none" || reduceMotion || !("IntersectionObserver" in window)) {
        wrapper.classList.add("is-lumo-section-in-view");
      }

      if (sectionBody.querySelector(".blog-route, .article-route") || sectionBody.matches(".blog-route, .article-route")) {
        wrapper.classList.add("is-lumo-section-in-view");
      }
    });

    if (reduceMotion || !("IntersectionObserver" in window)) return;

    if (!pageMotionObserver) {
      pageMotionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-lumo-section-in-view");
          pageMotionObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: "0px 0px -10% 0px" });
    }

    sections.forEach(function (wrapper) {
      if (wrapper.classList.contains("is-lumo-section-in-view")) return;
      if (wrapper.dataset.lumoAnimation === "none") return;
      var rect = wrapper.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        wrapper.classList.add("is-lumo-section-in-view");
        return;
      }
      pageMotionObserver.observe(wrapper);
    });
  }

  function initEcosystemSliders(scope) {
    (scope || document).querySelectorAll("[data-lumo-section-slider]").forEach(function (slider) {
      if (slider.dataset.lumoSliderReady === "true") return;
      var slides = Array.prototype.slice.call(slider.querySelectorAll("[data-lumo-slide]"));
      if (!slides.length) return;
      slider.dataset.lumoSliderReady = "true";
      var active = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains("is-active"); }));
      var prev = slider.querySelector("[data-lumo-slide-prev]");
      var next = slider.querySelector("[data-lumo-slide-next]");

      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle("is-active", slideIndex === active);
        });
      }

      if (prev) prev.addEventListener("click", function () { show(active - 1); });
      if (next) next.addEventListener("click", function () { show(active + 1); });
      show(active);
    });
  }

  function initEcosystemTabs(scope) {
    (scope || document).querySelectorAll("[data-lumo-tabs]").forEach(function (tabs) {
      if (tabs.dataset.lumoTabsReady === "true") return;
      tabs.dataset.lumoTabsReady = "true";
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll("[data-lumo-tab]"));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll("[data-lumo-tab-panel]"));

      function show(index) {
        buttons.forEach(function (button, buttonIndex) {
          button.setAttribute("aria-selected", buttonIndex === index ? "true" : "false");
        });
        panels.forEach(function (panel, panelIndex) {
          panel.classList.toggle("is-active", panelIndex === index);
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          show(Number(button.dataset.lumoTab || 0));
        });
      });
      show(0);
    });
  }

  function initEcosystemCountdowns(scope) {
    (scope || document).querySelectorAll("[data-lumo-countdown]").forEach(function (countdown) {
      if (countdown.dataset.lumoCountdownReady === "true") return;
      countdown.dataset.lumoCountdownReady = "true";
      var targetValue = countdown.dataset.lumoCountdown;
      var target = targetValue ? new Date(targetValue + "T23:59:59").getTime() : 0;
      var days = countdown.querySelector("[data-lumo-days]");
      var hours = countdown.querySelector("[data-lumo-hours]");
      var minutes = countdown.querySelector("[data-lumo-minutes]");
      var seconds = countdown.querySelector("[data-lumo-seconds]");

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, "0");
      }

      function sync() {
        var distance = Math.max(0, target - Date.now());
        var totalSeconds = Math.floor(distance / 1000);
        if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
        if (hours) hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        if (seconds) seconds.textContent = pad(totalSeconds % 60);
      }

      sync();
      window.setInterval(sync, 1000);
    });
  }

  function initEcosystemBeforeAfter(scope) {
    (scope || document).querySelectorAll("[data-lumo-before-after]").forEach(function (stage) {
      if (stage.dataset.lumoBeforeAfterReady === "true") return;
      var range = stage.querySelector("[data-lumo-before-after-range]");
      if (!range) return;
      stage.dataset.lumoBeforeAfterReady = "true";
      var dragging = false;

      function clamp(value) {
        return Math.min(100, Math.max(0, value));
      }

      function setSplit(value) {
        var next = clamp(Number(value || 50));
        stage.style.setProperty("--split", next + "%");
        range.value = String(next);
      }

      function pointerToPercent(event) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width) return Number(range.value || 50);
        return ((event.clientX - rect.left) / rect.width) * 100;
      }

      function startDrag(event) {
        if (event.button !== undefined && event.button !== 0) return;
        dragging = true;
        setSplit(pointerToPercent(event));
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {
          // Older webviews can miss pointer capture; move/up still work through the document listeners below.
        }
      }

      function moveDrag(event) {
        if (!dragging) return;
        setSplit(pointerToPercent(event));
      }

      function endDrag() {
        dragging = false;
      }

      range.addEventListener("input", function () {
        setSplit(range.value);
      });
      stage.addEventListener("pointerdown", startDrag);
      stage.addEventListener("pointermove", moveDrag);
      stage.addEventListener("pointerup", endDrag);
      stage.addEventListener("pointercancel", endDrag);
      document.addEventListener("pointerup", endDrag);
      setSplit(range.value);
    });
  }

  function initEcosystem(scope) {
    initPageSectionMotion(scope || document);
    initEcosystemReveal(scope || document);
    initEcosystemSliders(scope || document);
    initEcosystemTabs(scope || document);
    initEcosystemCountdowns(scope || document);
    initEcosystemBeforeAfter(scope || document);
  }

  function getPreviewThemeId() {
    if (!window.Shopify || !window.Shopify.previewMode || !window.Shopify.theme) return "";
    return window.Shopify.theme.id ? String(window.Shopify.theme.id) : "";
  }

  function withPreviewTheme(urlValue) {
    var themeId = getPreviewThemeId();
    if (!themeId) return urlValue;

    var url;
    try {
      url = new URL(urlValue || "", window.location.href);
    } catch (error) {
      return urlValue;
    }

    if (url.protocol !== "http:" && url.protocol !== "https:") return urlValue;
    if (url.origin !== window.location.origin) return urlValue;
    if (url.pathname.indexOf("/cdn/") === 0) return urlValue;

    url.searchParams.set("preview_theme_id", themeId);
    return url.pathname + url.search + url.hash;
  }

  function preservePreviewThemeLinks(scope) {
    var root = scope || document;
    if (!getPreviewThemeId()) return;

    root.querySelectorAll("a[href]").forEach(function (link) {
      var href = link.getAttribute("href") || "";
      if (!href || href.charAt(0) === "#" || /^mailto:|^tel:|^javascript:/i.test(href)) return;

      var nextHref = withPreviewTheme(href);
      if (nextHref !== href) link.setAttribute("href", nextHref);
    });
  }

  function initMobileNavigation(scope) {
    (scope || document).querySelectorAll(".site-nav").forEach(function (navShell) {
      if (navShell.dataset.lumoMobileNavReady === "true") return;
      var button = navShell.querySelector(".site-nav__menu-toggle");
      var nav = navShell.querySelector("nav");
      if (!button || !nav) return;

      navShell.dataset.lumoMobileNavReady = "true";

      function setOpen(open) {
        navShell.classList.toggle("is-menu-open", open);
        button.setAttribute("aria-expanded", open ? "true" : "false");
        button.setAttribute("aria-label", open ? "Close navigation menu" : "Open navigation menu");
      }

      button.addEventListener("click", function () {
        setOpen(button.getAttribute("aria-expanded") !== "true");
      });

      nav.addEventListener("click", function (event) {
        if (event.target.closest("a")) setOpen(false);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") setOpen(false);
      });

      window.addEventListener("resize", function () {
        if (window.innerWidth > 760) setOpen(false);
      });
    });
  }

  function initCustomizers() {
    if (window.LumoPaddleCustomizer) window.LumoPaddleCustomizer.initAll();
    if (window.LumoEdgeGuardCustomizer) window.LumoEdgeGuardCustomizer.initAll();
    initStickyState();
    initQuantities(document);
    initGenericProductGalleries(document);
    initEcosystem(document);
    initMobileNavigation(document);
    preservePreviewThemeLinks(document);
  }

  document.addEventListener("DOMContentLoaded", initCustomizers);
  document.addEventListener("shopify:section:load", function (event) {
    initQuantities(event.target);
    initGenericProductGalleries(event.target);
    initEcosystem(event.target);
    initMobileNavigation(event.target);
    preservePreviewThemeLinks(event.target);
    initCustomizers();
  });

  window.Lumo5177Theme = {
    init: initCustomizers
  };
}());
